/**
 * WD PREMIER — Mini-cart when `on_success=force_open_drawer` (product-card quick-add, FBT).
 * Keeps Prestige theme.js stock; patches cart:change before cart-drawer handles it.
 */
(function () {
  function getCartDrawer() {
    return document.getElementById('cart-drawer');
  }

  function getCartDrawerSectionId() {
    const drawer = getCartDrawer();
    if (!drawer) return '';

    const sectionEl = drawer.closest('.shopify-section[id^="shopify-section-"]');
    return sectionEl?.id?.replace(/^shopify-section-/, '') || '';
  }

  function isQuickAddForceDrawer(detail) {
    return detail?.baseEvent === 'variant:add' && detail?.onSuccessDo === 'force_open_drawer';
  }

  function shouldOpenDrawer(detail) {
    return (
      (window.themeVariables?.settings?.cartType === 'drawer' ||
        detail?.onSuccessDo === 'force_open_drawer') &&
      detail?.baseEvent === 'variant:add'
    );
  }

  function dispatchCartChange(detail) {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', { bubbles: true, composed: true, detail })
    );
  }

  function refreshDrawerAndShow() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    requestAnimationFrame(() => getCartDrawer()?.show?.());
  }

  function fetchCartDrawerSectionHtml(sectionId) {
    return fetch(`${Shopify.routes.root}?section_id=${encodeURIComponent(sectionId)}`, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    }).then((response) => {
      if (!response.ok) {
        throw new Error(`cart drawer section fetch failed (${response.status})`);
      }
      return response.text();
    });
  }

  /** Ensure cart/add.js requests cart-drawer section HTML in the bundled sections param. */
  function ensureBundledSections(event) {
    const sectionId = getCartDrawerSectionId();
    if (!sectionId || event.detail.sections.includes(sectionId)) return;
    event.detail.sections.push(sectionId);
  }

  /**
   * Capture cart:change for quick-add: inject fresh drawer HTML, then re-dispatch so
   * cart-drawer replaceContent + show run with valid section markup.
   */
  function ensureCartDrawerSectionOnChange(event) {
    const detail = event.detail;
    if (!detail?.cart || !isQuickAddForceDrawer(detail)) return;
    if (detail.__wdPremierCartDrawerHandled) return;

    const sectionId = getCartDrawerSectionId();
    if (!sectionId) {
      event.stopPropagation();
      event.stopImmediatePropagation();
      detail.__wdPremierCartDrawerHandled = true;
      refreshDrawerAndShow();
      return;
    }

    event.stopPropagation();
    event.stopImmediatePropagation();

    fetchCartDrawerSectionHtml(sectionId)
      .then((html) => {
        detail.cart.sections = { ...(detail.cart.sections || {}), [sectionId]: html };
        detail.__wdPremierCartDrawerHandled = true;
        dispatchCartChange(detail);
      })
      .catch(() => {
        detail.__wdPremierCartDrawerHandled = true;
        refreshDrawerAndShow();
      });
  }

  function openCartDrawerOnForceOpen(event) {
    if (!shouldOpenDrawer(event.detail)) return;
    getCartDrawer()?.show?.();
  }

  /** Backup: refresh drawer HTML after cart:change (covers replaceContent failures). */
  function reinforceDrawerRefresh(event) {
    if (!isQuickAddForceDrawer(event.detail)) return;
    requestAnimationFrame(() => {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    });
  }

  function init() {
    document.addEventListener('cart:prepare-bundled-sections', ensureBundledSections, true);
    document.addEventListener('cart:change', ensureCartDrawerSectionOnChange, true);
    document.addEventListener('cart:change', openCartDrawerOnForceOpen);
    document.addEventListener('cart:change', reinforceDrawerRefresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
